<template>
  <div>
    <h4>
      {{ $t('SharingModalContent.title') }}
    </h4>
    <p>
      {{ $t('SharingModalContent.wantToShow') }}
    </p>
    <p
      v-if="!organizationPersonal"
      v-html="
        $t('SharingModalContent.shareWithColleagues', { userInvitationPath: this.userInvitationPath })
      "
    />
    <div>
      <div class="form-check">
        <input
          type="checkbox"
          class="form-check-input"
          id="sharingCheckbox"
          v-model="isShared"
          @change="updateShareState"
        >
        <label for="sharingCheckbox" class="form-check-label">
          {{ $t('SharingModalContent.enablePrivateSharing') }}
        </label>
      </div>
    </div>

    <div class="pt-3">
      <div class="input-group" id="sharedLink" v-show="isShared">
        <input
          class="form-control project-url"
          :value="projectPath"
          type="text"
          readonly
        >
        <button
          class="btn btn-outline-primary"
          @click="copyUrlToClipboard"
        >
          {{ buttonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { putRequest } from 'helper/request';
import messages from 'locales/SharingModalContent';

export default {
  name: 'SharingModalContent',
  data() {
    return {
      buttonText: this.$t('SharingModalContent.copyToShare'),
      isShared: this.isSharedCurrently || false,
    };
  },
  props: {
    isSharedCurrently: Boolean,
    projectPath: String,
    userInvitationPath: String,
    organizationPersonal: Boolean,
  },
  methods: {
    copyUrlToClipboard() {
      navigator.clipboard.writeText(this.projectPath);
      this.buttonText = this.$t('SharingModalContent.copied');
    },
    async updateShareState() {
      const sharedState = this.isShared ? 'shared' : 'shared_none';

      await putRequest(this.projectPath, { data: { project: { shared: sharedState } } });
    },
  },
  i18n: { messages },
};
</script>

<style lang='scss' scoped>

</style>
